import { Link } from "react-router-dom";

const TopNav = () => {
    return (
        <div className="page-header">
            <div className="btn-group btn-group-lg top-nav" role="group">
                <Link to="/about" className="btn-who btn lg">!who:</Link>
                <Link to="/engagements" className="btn-what btn lg">!what:</Link>
                <Link to="/contact" className="btn-where btn lg">!where:</Link>
            </div>
        </div>)
}
export default TopNav;